import { ActivityOption } from "$utils/typeConstants";
import GenericSelect from "./GenericSelect";
import JSelectDisplayOption from "$components/JSelectDisplayOption/JSelectDisplayOption";

type Props = {
  activitiesOptions: ActivityOption[];
  onChange: (activityId, activity) => void;
  value: any;
  error?: boolean;
  multiple?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: any;
  renderOption?: (opt) => JSX.Element;
  label?: string;
  placeholder?: string;
  valueKey?: string;
};

function ActivitiesSelect({
  activitiesOptions,
  disabled,
  label = "Activité(s)",
  placeholder,
  valueKey = "value",
  ...props
}: Props) {
  return (
    <GenericSelect
      valueKey={valueKey}
      label={label}
      placeholder={placeholder}
      getOptionLabel={(option: any) => option?.label}
      disabled={disabled || activitiesOptions.length === 0}
      options={activitiesOptions || []}
      renderOption={(props: any) => (
        <JSelectDisplayOption value1={props.label} />
      )}
      {...props}
    />
  );
}

export default ActivitiesSelect;
